// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2o6mz","popupLayout":"styles_popupLayout__1DKs7","popup":"styles_popup__JKTNd"};